import React, { useState, useEffect, useRef } from "react";
import { useLocalStorage } from "../../../../state/Storage";
import Check from "../../../utils/icons/Check";
import Close from "../../../utils/icons/Close";
import { closePopUp } from "../../../utils/Overlay";

function isEmailValid(email) {
  return /(.+)@(.+){2,}\.(.+){2,}/.test(email);
}

const [setSubjectLS, getSubjectLS] = useLocalStorage("mailchimp_subject", "");
const [setFromNameLS, getFromNameLS] = useLocalStorage("mailchimp_from", "");
const [setFromEmailLS, getFromEmailLS] = useLocalStorage("mailchimp_email", "");

export default function CollectDestinationData({
  onCollect,
  onCancel,
  destination,
}: {
  onCollect: Function;
  onCancel: Function;
  destination: Destination;
}) {
  const [subject, setSubject] = useState(getSubjectLS());
  const [fromName, setFromName] = useState(getFromNameLS());
  const [fromEmail, setFromEmail] = useState(getFromEmailLS());
  const [valid, setValidFlag] = useState(false);
  const subjectInput = useRef(null);

  useEffect(() => {
    setValidFlag(
      subject !== "" &&
        fromName !== "" &&
        fromEmail !== "" &&
        isEmailValid(fromEmail)
    );
  }, [subject, fromName, fromEmail]);

  useEffect(() => {
    subjectInput.current.focus();
  }, []);

  return (
    <div className="cf">
      <h3 className="tac">
        Type in your Mailchimp
        <br />
        campaign details.
      </h3>
      <small className="tac block mt1">
        "From (email)" field should contain valid and verified email. More about
        that{" "}
        <a href="https://mailchimp.com/help/verify-a-domain/" target="_blank">
          here
        </a>
        .
      </small>
      <input
        type="text"
        className="block mt1"
        placeholder="Subject"
        ref={subjectInput}
        value={subject}
        onChange={(e) => {
          setSubject(e.target.value);
          setSubjectLS(e.target.value);
        }}
      />
      <input
        type="text"
        className="block"
        placeholder="From (name)"
        value={fromName}
        onChange={(e) => {
          setFromName(e.target.value);
          setFromNameLS(e.target.value);
        }}
      />
      <input
        type="email"
        className="block"
        placeholder="From (email)"
        value={fromEmail}
        onChange={(e) => {
          setFromEmail(e.target.value);
          setFromEmailLS(e.target.value);
        }}
      />
      <div className="right">
        <button
          type="button"
          className="reset as-link ib fz1 with-icon"
          onClick={() => {
            onCancel(destination);
            closePopUp();
          }}
        >
          <Close size={20} /> Cancel
        </button>
        <button
          type="button"
          className="reset secondary ml1 with-icon"
          onClick={() => {
            onCollect(destination, subject, fromName, fromEmail);
          }}
          disabled={!valid}
        >
          <Check size={16} /> Set
        </button>
      </div>
    </div>
  );
}
